import React from 'react';
import { injectIntl } from 'react-intl';

import constants from '../../../constants';
import styled from './styled';

class UserCell extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      debug: false,
      mouseOverBottomLine: false,
      bottomLinePos: null,
    };

    this.bottomLineRef = React.createRef();
    this.oneItemRef = React.createRef();

    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentDidUpdate() {
    // Component update handler
  }

  componentWillUnmount() {

    this._isMounted = false;
  }

  mouseEnterBL = () => {
    this.setState({ mouseOverBottomLine: true });
  }

  mouseLeaveBL = () => {
    this.setState({ mouseOverBottomLine: false });
  }

  mouseEnterOneItem = () => {
    this.setState({ mouseOverBottomLine: true });
  }

  mouseLeaveOneItem = () => {
    this.setState({ mouseOverBottomLine: false });
  }

  renderBottomLineMouseTip = () => {
    const { bottomLinePos, } = this.state;

    if (bottomLinePos) {
      const bottomLineContainerStyle = {
        top: bottomLinePos.top,
        left: bottomLinePos.left,
        width: bottomLinePos.width,
        height: bottomLinePos.height,
        position: 'absolute',
        backgroundColor: 'white',
        boxShadow: '0 5px 10px 2px rgba(195,192,192,.5)',
        zIndex: 2,
        borderRadius: '5px',
        paddingTop: '5px',
        //border: '1px solid red',
      };
      const test = `top: ${bottomLinePos.top}, left: ${bottomLinePos.left}, w: ${bottomLinePos.width}, h: ${bottomLinePos.height}`;
      return (
        <div style={bottomLineContainerStyle}>
          <div className="mouse-tip__top-wrap">{test}</div>
        </div>
      );
    }
  }

  render() {
    //user.id => user privilege id
    //user.owner_id => user id
    const { user } = this.props;
    const { debug, mouseOverBottomLine, } = this.state;
    const { statusTypes } = constants;

    const userImageUrl = user && user.profile_image_thumb_url ?
      user.profile_image_thumb_url : '/icons/default-profile-thumb.svg';
    const userName = user ? `${user.first_name} ${user.last_name}` : '';
    const approvedBadge = '/icons/verified-badge-icon.svg';

    var allowProfile =
      user.status !== statusTypes.REMOVED &&
      user.status !== statusTypes.REJECTED &&
      user.status !== statusTypes.WITHDRAWN &&
      user.status !== statusTypes.BLOCKED &&
      user.status !== 'unregistered' ;

    let bottomLine = null;
    if (user) {
      if (user.position && !user.badge_id) {
        bottomLine = (<styled.BottomLineTextOneItem
          ref={this.oneItemRef}
          onMouseEnter={this.mouseEnterOneItem}
          onMouseLeave={this.mouseLeaveOneItem}
        >{user.position}</styled.BottomLineTextOneItem>);
      } else if (!user.position && user.badge_id) {

        bottomLine = (<styled.BottomLineTextOneItem
          ref={this.oneItemRef}
          onMouseEnter={this.mouseEnterOneItem}
          onMouseLeave={this.mouseLeaveOneItem}
        ></styled.BottomLineTextOneItem>)
      } else if (!user.position && !user.badge_id) {
        bottomLine = (<styled.BottomLineTextOneItem
          ref={this.oneItemRef}
          onMouseEnter={this.mouseEnterOneItem}
          onMouseLeave={this.mouseLeaveOneItem}
        ></styled.BottomLineTextOneItem>)
      } else {
        bottomLine = (
          <styled.BottomLineWrap
            ref={this.bottomLineRef}
            onMouseEnter={this.mouseEnterBL}
            onMouseLeave={this.mouseLeaveBL}
          >
            <styled.BottomLineText>{user.position}</styled.BottomLineText>
          </styled.BottomLineWrap>);
      }
    }

    const profileUrl = ( (user.status == 'unregistered') ? `unreg/${user.id}` : user.id );

    return (
      <styled.TopWrap>
        <styled.OwnerAvatar src={userImageUrl} />
        <styled.OwnerInfoWrap>
          <styled.OwnerInfoTopLine>
            {allowProfile ? <styled.ProfileLink to={`/team/${profileUrl}`}>{userName}</styled.ProfileLink> : <styled.UserName>{userName}</styled.UserName>}
            {user && user.is_admin && <styled.ApprovedBadge src={approvedBadge} />}
          </styled.OwnerInfoTopLine>
          {debug ? user.owner_id : bottomLine}
        </styled.OwnerInfoWrap>
      </styled.TopWrap>
    );
  }
}

export default injectIntl(UserCell);

/*

registered user:
{"_parent_object_id":null,"id":24707,"email":null,"position":"Tt67","badge_id":"","owner_id":16132,"first_name":"Ggy","last_name":"5102","phone_number":"18882795102","profile_image_thumb_url":"https://files.myshyft.com/shyft-app-images/avatar1.png","is_admin":false,"status":"active","is_invisible":false,"department_ids":[],"user":{"_parent_object_id":24707,"id":16132,"skill_ids":[],"channel_ids":[11476,11477]}}

unregistered user:
{"_parent_object_id":null,"id":473555,"first_name":"Tom","last_name":"Batman","phone_number":null,"email":null,"internal_id":null,"setup_id":null,"status":"unregistered"}

*/